module.exports = {
  VUE_APP_API_URL: process.env.VUE_APP_API_URL || 'https://erqplay.tigre.com/webservice/',
  VUE_APP_NEWAPI_URL: process.env.VUE_APP_NEWAPI_URL,
  VUE_APP_CLIENT_ID: process.env.VUE_APP_CLIENT_ID || '68c4491a-36da-45af-b3b7-b26ed33f2691',
  VUE_APP_REDIRECT: process.env.VUE_APP_REDIRECT || 'http://localhost:8081',
  VUE_APP_LOGIN: process.env.VUE_APP_LOGIN || 'https://tigreb2c.b2clogin.com/tigreb2c.onmicrosoft.com/B2C_1A_signup_signin_oauth',
  APP_DRIVEIN_TRACK_URL: process.env.DRIVEIN_TRACK_URL || 'https://lite.driv.in/widget?token=eyJpc28iOiJjbyIsInBvc2l0aW9uIjpbeyJsYXQiOjQuNzU3Nzc4MywibG5nIjotNzQuMTUzNDYxfV0sImxvY2FsZSI6ImVzIiwidGltZV96b25lIjoiQm9nb3RhIiwiaWQiOjEwMDAwMzcyLCJkYXRhIjp7ImFwaV9rZXkiOiIyYmNiMGJmZi00YmJiLTQzMGUtODMwNC02NmM3OTdiYWY3YTcifX0%3D&order_code=',
  VUE_APP_COUNTRY: process.env.VUE_APP_COUNTRY,
  VUE_APP_DECIMALS: Number(process.env.VUE_APP_DECIMALS),

  countries: {
    EC: {
      CATALOG_URL: 'https://www.tigre.com.ec/productos',
      FACTURAS_URL: 'https://quindefee.com/quinde/login',
      WHATSAPP: '593991911868',
      AYUDA: {
        TITLE: 'La confianza de nuestros clientes es lo más importante',
        DESCRIPTION: '¡Los escuchamos siempre!',
        LABEL: '¡CONTACTANOS!',
        LINK: 'https://forms.office.com/r/7M05gFKyRZ'
      },
      CONTACT: [
        { 
          title: 'Administrativa', 
          information: [
            { label: '', value: 'Dirección Carapungo El Vergel Lote 19 y Giovanni Calles Quito-Ecuador'},
            { label: 'Email', type:"email", value: 'servicioalcliente@tigre.com'},
          ]
        },
        { 
          title: 'Teléfonos',
          information: [
            { label: 'Servicio al cliente', value: '+593 99 191 1868'},
            { label: 'Asistencia Técnica', value: '+593 99 148 4475'},
            { label: 'RRHH', value: '+593 98 333 1515'},
            { label: 'Financiero', value: '+593 98 024 5729'},
            { label: 'Compras', value: '+593 99 146 4044'},
          ]
        }
      ],
    },
    CO: {
      CATALOG_URL: 'https://www.tigre.com.co/productos',
      FACTURAS_URL: 'https://cenf.cen.biz/site/',
      WHATSAPP: '573168523934',
      AYUDA: {
        TITLE: 'La confianza de nuestros clientes es lo más importante',
        DESCRIPTION: '¡Los escuchamos siempre!',
        LABEL: '¡CONTACTANOS!',
        LINK: 'https://forms.office.com/Pages/ResponsePage.aspx?id=Ng8TUvS4FU-WUZcNZHo4y3c53Sd-E_dKqjS-2o2ndrVUMlhLMVhRUVdNNEhSUldLQ1BURDZDVkcyVi4u'
      },
      CONTACT: [
        { 
          title: 'Administrativa', 
          information: [
            { label: '', value: 'KM 1.5 Vía Sibéria - Condomínio Empresarial Potrero Chico, Parque Industrial Robles II Bodega 7 y 8.Cota - Colombia'},
            { label: '', value: '(601) 7426465'},
            { label: 'Email', type:"email", value: 'servicioalclientecol@tigre.com'},
          ]
        },
        { 
          title: 'Celulares', 
          information: [
            { label: 'Servicio al cliente', value: '316 8523934 / 315 3720251'},
            { label: 'Admin. Ventas', value: '320 3040 758'},
            { label: 'Ventas de exportación Centroamérica y Caribe', value: '(+57) 315 3653 077'},
            { label: 'Asistencia Técnica', value: '320 3040 831'},
            { label: 'Recursos Humanos', value: '310 2481 361'},
            { label: 'Contabilidad', value: '320 3040 821'},
            { label: 'Logística', value: '321 4900 219'},
            { label: 'Compras', value: '320 8597 965'},
            { label: 'Calidad', value: '313 4794 822'},
          ]
        }
      ],
    },
    UY: {
      WHATSAPP: '598093474776',
      AYUDA: {
        TITLE: 'La confianza de nuestros clientes es lo más importante',
        DESCRIPTION: '¡Los escuchamos siempre!',
        LABEL: '¡CONTACTANOS!',
        LINK: 'https://forms.office.com/r/4ArJFWURkw'
      },
      CONTACT: [
        { 
          title: 'Administrativa', 
          information: [
            { label: 'PLANTA', value: 'Ruta 1 KM 46.200, Liberdad / San Jóse'},
            { label: 'ADMINISTRACIÓN', value: 'Av. Lezica, 6692, Montevideo'},
            { label: 'Teléfonos', value: '(00598) 43453511 / 0800-8343'},
            { label: 'Email', type:"email", value: 'servicioalcliente.uruguay@tigre.com'},
          ]
        },
        { 
          title: 'Anexos Internos', 
          information: [
            { label: 'Servicio al cliente', value: '100 - 101 - 401'},
            { label: 'Canal de Ética', value: '000-416-205-2744'},
            { label: 'Logística', value: '200 - 203 - 411'},
            { label: 'Fax', value: '110'},
            { label: 'Administración', value: '403 - 404'},
          ]
        }
      ],
      CATALOG_URL: 'https://www.tigre.com.uy/productos',
    }
  },
};